// ** Redux Imports
import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from '../../../services/ApiService'

interface AccessTokenPayload {
    providerName: string;
    accessToken: string;
}

export const updateOrganizationName = createAsyncThunk(
    'appLookup/updateOrganizationName',
    async (orgName : string, { dispatch, getState }) => {
        const response = await axios.put('invite/UpdateOrganizationName?organizatioName=' + orgName);

        // Find the active organization's index to update its name in the store
        const state : any = getState();
        const deafultOrgIndex = state.lookup.data.userOrgChannels.organizations.findIndex(
            (org: any) => org.isDefaultOrg
        );

        // Dispatch an action to update the organization name in the store
        if (deafultOrgIndex !== -1) {
            dispatch(setOrganizationName({ orgIndex: deafultOrgIndex, orgName }));
        }

        return response;
    }
);

export const initOrgUser = createAsyncThunk('appLookup/initOrgUser', async () => {
    const response = await axios.get('invite/InitOrganizationUser')
    return response;
})

// ** Fetch Lookups
export const fetchLookups = createAsyncThunk('appLookup/fetchLookups', async () => {
    const response = await axios.get('lookup')
    return response;
})

export const setActiveOrg = createAsyncThunk('appLookup/setActiveOrg', async (orgId: number, { dispatch }) => {
    const response = await axios.post('invite/setActiveOrg?orgId=' + orgId);
    await dispatch(fetchLookups());
    return response;
})

export const appLookupSlice = createSlice({
    name: 'appChannel',
    initialState: {
        data: {
            channelTypes: [{
                name: '',
                id: 0,
                mediumId : 0
            }],
            mediums: [{
                name: '',
                id: 0
            }
            ],
            accessTokens : {},
            userAccessToken: '',
            userOrgChannels: {
                organizations: [{
                    name: '',
                    id: 0,
                    active: true,
                    isDefaultOrg : false,
                    channels: []
                }]
                }
        }
    },
    reducers: {
        setActive(state, action) {
            const { orgId } = action.payload;
            const org = state.data.userOrgChannels.organizations.find(org => org.id === orgId);
            if (org) {
                org.active = true;
            }
        },
        setOrganizationName(state, action) {
            const { orgIndex, orgName } = action.payload;
            state.data.userOrgChannels.organizations[orgIndex].name = orgName;
        },
        setAccessToken(state, action: PayloadAction<AccessTokenPayload>) {
            const { providerName, accessToken } = action.payload;
            if (!state.data.accessTokens) {
                state.data.accessTokens = {};
            }
            // @ts-ignore
            state.data.accessTokens[`${providerName}_accessToken`] = accessToken;
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchLookups.fulfilled, (state, action) => {
            state.data = action.payload.data
        })
    }
})

export const { setActive, setOrganizationName, setAccessToken } = appLookupSlice.actions;

export default appLookupSlice.reducer
